// extracted by mini-css-extract-plugin
export default {"whiffs_chart-mini":"styles_whiffs_chart-mini__UssKL","title-mini":"styles_title-mini__jM++4"};